export default __webpack_public_path__ + "e7ecb03b270636f4642a1dfd9aefbafd.woff2";